import { Box } from "@chakra-ui/react"

export const ZurichFlag = () => {
    return <Box
        as="svg"
        //xmlns="http://www.w3.org/2000/svg"
        fill="none"
        boxSize='1rem'
        borderWidth='1px'
    >
        <rect width="100" height="100" fill="white" />
        <polygon points="0,0 100,100 0,100" fill="#007AC8" />
    </Box>
}

export default ZurichFlag;